import { render, staticRenderFns } from "./PriceListMod.vue?vue&type=template&id=7ac4afb1&scoped=true&"
import script from "./PriceListMod.vue?vue&type=script&lang=js&"
export * from "./PriceListMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4afb1",
  null
  
)

export default component.exports